import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

type WrapperProps = {
  selected: boolean;
} & SpaceProps;

export const Wrapper = styled.label<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  border: 1px solid
    ${({ theme, selected }) =>
      selected ? theme.colors.success.main : theme.colors.gray.extraLight};
  border-radius: ${({ theme }) => theme.radii[3]}px;
  box-shadow: 0px 8px 16px rgba(2, 11, 17, 0.15);

  ${space};
`;
